import { render, staticRenderFns } from "./cgBiddingNotice.vue?vue&type=template&id=1099751b&scoped=true&"
import script from "./cgBiddingNotice.vue?vue&type=script&lang=js&"
export * from "./cgBiddingNotice.vue?vue&type=script&lang=js&"
import style0 from "./cgBiddingNotice.vue?vue&type=style&index=0&id=1099751b&prod&lang=scss&scoped=true&"
import style1 from "./cgBiddingNotice.vue?vue&type=style&index=1&id=1099751b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1099751b",
  null
  
)

export default component.exports